"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MissionVision() {
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="missionvision" className="relative bg-dark-background text-foreground-dark py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={cardRef} className={`transition-all duration-[var(--duration-slow)] ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="bg-primary-dark/40 border border-border-strong/30 shadow-strong backdrop-blur-sm">
            <CardHeader className="text-center">
              <CardTitle className="text-3xl md:text-4xl font-display text-foreground">
                Our Mission & Vision
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-secondary-dark mb-3">
                  Mission
                </h3>
                <p className="text-muted leading-relaxed">
                  At AA Eagle Plumbing, our mission is to deliver fast, reliable, and high-quality water pump services to both commercial and residential customers. We are committed to providing expert solutions for complex pump systems including fire pumps, boiler feed pumps, chill water pumps, cooling towers, booster pumps, sewage lift stations, line-shaft turbines, and submersible pumps, ensuring dependable performance and customer satisfaction with every project.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-secondary-dark mb-3">
                  Vision
                </h3>
                <p className="text-muted leading-relaxed">
                  Our vision is to be the most trusted name in water pump services, recognized for our technical expertise, timely workmanship, and unwavering dedication to quality. We strive to set the standard for excellence in water pump system maintenance and repair, empowering our clients with solutions that ensure safety, efficiency, and long-term reliability.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}